import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type PublishableFragment = { isPublishable: boolean, reason?: Types.ContentPublishFailureReasonEnum | null };


export type PublishableFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const PublishableFragmentDoc = /*#__PURE__*/ gql`
    fragment Publishable on CheckContentPublishablePayload {
  isPublishable
  reason
}
    `;